import { API_PREFIX } from "../config/appConfig";
import ApiService from "./api.service";

// payment.service.js
const PaymentService = {

    createCheckoutSession: async (appointmentId, amount) => {
        // Ottieni il token esplicitamente
        const token = localStorage.getItem('auth_token');
        console.log('Using token for payment:', token);
        
        const response = await fetch(`${API_PREFIX}/payment/create-checkout-session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ appointment_id: appointmentId, amount })
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Errore nella creazione della sessione di pagamento');
        }
        
        return response.json();
      },
      
     // Nuovo metodo per ottenere i pagamenti
     getPayments: () => ApiService.fetch('payments'),
    
     // Per gli admin
     getAllPayments: () => ApiService.fetch('admin/payments'),

     // Aggiungi questo al tuo PaymentService
    confirmSession: (sessionId) => ApiService.fetch(`payment/confirm-session/${sessionId}`, {
        method: 'POST'
    }),

    // Verifica eligibilità sconto
    checkDiscount: (therapistId, price) => ApiService.fetch('payment/check-discount', {
        method: 'POST',
        body: JSON.stringify({ therapist_id: therapistId, price })
    }),
};

export default PaymentService;